/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Typography, Button, Link, Alert, } from '@one-thd/sui-atomic-components';
import { Printer, ShareWeb } from '@one-thd/sui-icons';
import { addManageUsersApi } from '../../api/b2b/add-manage-user';
import { useAddManageUsers } from '../../hooks/use-add-manage-users';
import { USER_FORM_MODE } from '../../models/b2b/add-manage-users';
import { setHeaderLinkAnalytics } from '../../utils/add-manage-user-analytics';
import { getDate, saveFile } from './manage-users-header-helpers';
import { TAlertStatus, TAlertType } from '../../models/common/alert-messages';
import { ERR_UNABLE_TO_EXPORT_OR_PRINT } from '../../constants/response-error-messages';
import { FILE_EXPORTED_SUCCESS_MSG, FILE_PRINTED_SUCCESS_MSG, } from '../../constants/response-success-messages';
export var ManageUsersHeader = function (_a) {
    var onLoading = _a.onLoading, onOpenForms = _a.onOpenForms;
    var _b = useAddManageUsers(), paginationInfo = _b.paginationInfo, alertMessage = _b.alertMessage, isBulkAddUserAllowed = _b.isBulkAddUserAllowed, setAlertMessage = _b.setAlertMessage, setFormMode = _b.setFormMode;
    var _c = useContext(ExperienceContext), channel = _c.channel, isConsumerApp = _c.isConsumerApp;
    var isDesktop = channel === 'desktop';
    var usersLength = (paginationInfo === null || paginationInfo === void 0 ? void 0 : paginationInfo.totalNumberOfRecords) || '0';
    var onExportToCSV = function () {
        setHeaderLinkAnalytics('export');
        onDownloadFile('csv');
    };
    var onPrintToPDF = function () {
        setHeaderLinkAnalytics('print');
        onDownloadFile('pdf');
    };
    var isDownloadAlert = (alertMessage === null || alertMessage === void 0 ? void 0 : alertMessage.type) === TAlertType.PRINT_EXPORT;
    var onDownloadFile = function (filetype) {
        onLoading(true);
        setAlertMessage(null);
        var filename = "THD_USERS_".concat(getDate(), ".").concat(filetype);
        addManageUsersApi
            .downloadUsers(filename, filetype)
            .then(function (response) {
            return response.data;
        })
            .then(function (data) {
            setAlertMessage({
                text: filetype === 'csv'
                    ? FILE_EXPORTED_SUCCESS_MSG.message
                    : FILE_PRINTED_SUCCESS_MSG.message,
                alertStatus: TAlertStatus.SUCCESS,
                type: TAlertType.PRINT_EXPORT,
            });
            saveFile(data, filename, filetype);
        })
            .catch(function () {
            setAlertMessage({
                text: ERR_UNABLE_TO_EXPORT_OR_PRINT.message,
                alertStatus: TAlertStatus.ERROR,
                type: TAlertType.PRINT_EXPORT,
            });
        })
            .finally(function () {
            onLoading(false);
        });
    };
    return (React.createElement("div", { className: "sui-grid sui-grid-cols-1 md:sui-grid-cols-6 sui-gap-y-6 md:sui-gap-x-8 md:sui-gap-y-8 sui-mb-6 md:sui-mb-6 sui-items-center" },
        React.createElement("div", { className: "sui-flex sui-order-2 md:sui-order-1 sui-col-span-1 md:sui-col-span-3 " },
            React.createElement(Typography, { weight: "display", variant: "h2", uppercase: true },
                "Users (",
                usersLength,
                ")")),
        isDesktop && isBulkAddUserAllowed && (React.createElement("div", { className: "sui-flex sui-order-3 md:sui-order-2 sui-col-span-1 sui-items-center sui-justify-end" },
            React.createElement(Link, { component: "button", onClick: function () {
                    setAlertMessage(null);
                    setFormMode(USER_FORM_MODE.BULK_ADD);
                    onOpenForms();
                } }, "Bulk Add Users"))),
        React.createElement("div", { className: "sui-flex sui-order-1 md:sui-order-3 sui-col-span-1 md:sui-col-span-2 md:sui-col-start-5" },
            React.createElement(Button, { fullWidth: true, onClick: function () {
                    setAlertMessage(null);
                    setFormMode(USER_FORM_MODE.ADD_USER);
                    onOpenForms();
                } }, "Add User")),
        usersLength && !isConsumerApp && (React.createElement("div", { className: "sui-order-3 sui-col-span-full md:sui-justify-self-end md:sui-order-4 sui-flex" },
            React.createElement(Button, { onClick: onExportToCSV, className: "md:sui-ml-0 sui-ml-auto sui-block hover:sui-fill-brand sui-flex sui-gap-1" },
                React.createElement(ShareWeb, null),
                React.createElement(Typography, { className: "sui-font-regular sui-text-base", decoration: "underline" }, "Export")),
            isDesktop && (React.createElement(Button, { onClick: onPrintToPDF, className: "sui-ml-14 hover:sui-fill-brand sui-flex sui-gap-1" },
                React.createElement(Printer, { size: "regular" }),
                React.createElement(Typography, { className: "sui-font-regular sui-text-base", decoration: "underline" }, "Print"))))),
        isDownloadAlert && (React.createElement("div", { className: "sui-order-4 sui-col-span-full -sui-mb-4" },
            React.createElement(Alert, { "data-testid": "topAlertMsg", onClose: function () { return setAlertMessage(null); }, status: alertMessage.alertStatus }, alertMessage.text)))));
};
